import React, { useState} from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Divider,
  Avatar,
  Menu,
  MenuItem,
  useMediaQuery
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useAuth } from "../context/AuthContext"; 
import logo from "../assets/images/CWA_logo.png";



const Header = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:900px)");
  const { user, logout } = useAuth(); 

  const [openDrawer, setOpenDrawer] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const toggleDrawer = (state) => () => {
    setOpenDrawer(state);
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const navLinks = [
    { title: "Home", path: "/" },
    { title: "About Us", path: "/aboutus" },
    { title: "Our People", path: "/our-people" },
    { title: "Leadership", path: "/leadership" },
    { title: "Gallery", path: "/gallery" }
  ];

  const handleNavigation = (path) => {
    if (path === "/our-people") {
      if (window.location.pathname === "/") {
        const section = document.getElementById("our-people-section");
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        navigate("/");
        setTimeout(() => {
          const section = document.getElementById("our-people-section");
          if (section) {
            section.scrollIntoView({ behavior: "smooth" });
          }
        }, 500);
      }
    } else {
      navigate(path);
    }
    setOpenDrawer(false);
  };

  const storedUser = localStorage.getItem("first_name");
  const storedUserType = localStorage.getItem("user_type");
  const paymentStatus = localStorage.getItem("Payment_Status"); 
  const idCardStatus = localStorage.getItem("ID_Card");

 

  const userType =
  storedUserType === "user" && paymentStatus === "Paid" && idCardStatus === "Generated"
    ? "TKS Member"
    : storedUserType;

  

  return (
    <AppBar position="static" sx={{ backgroundColor: "#FAD707" }}>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        {/* Logo */}
        <Box>
        <Link to="/">
          <img src={logo} alt="Temple Logo" style={{ width: "140px", height: "auto" }} />
          </Link>
        </Box>

        {/* Desktop Navigation */}
        {!isMobile && (
          <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "center", gap: 3 }}>
            {navLinks.map((link, index) => (
              <Typography
                key={index}
                variant="h6"
                sx={{ textDecoration: "none", color: "#000000", fontWeight: 500, cursor: "pointer" }}
                onClick={() => handleNavigation(link.path)}
              >
                {link.title}
              </Typography>
            ))}
          </Box>
        )}

        {/* User Profile Dropdown OR Login/Register Buttons */}
        {user ? (
          <>
            <IconButton onClick={handleMenuOpen} color="inherit">
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mr: 1 }}>
                <Typography variant="body1" sx={{ color: "#000000", fontWeight: "bold" }}>
                  Hi! {storedUser}
                </Typography>
                {userType !== "user" && (
      <Typography variant="body2" sx={{ color: "#000000" }}>
        {userType}
      </Typography>
    )}
              </Box>
              <Avatar sx={{ bgcolor: "#47933A", color: "white" }}>
                {storedUser ? storedUser.charAt(0).toUpperCase() : <AccountCircleIcon />}
              </Avatar>
              <ArrowDropDownIcon sx={{ color: "#000000", fontSize: 30, marginLeft: "5px" }} />
            </IconButton>
            <Menu
              color="#000000"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem onClick={() => { navigate("/profile"); handleMenuClose(); }}>My Profile</MenuItem>
              <MenuItem onClick={() => { navigate("/membership"); handleMenuClose(); }}>Membership ID</MenuItem>
              {user?.role === "superuser" && (
                <MenuItem onClick={() => { navigate("/manageusers"); handleMenuClose(); }}>Manage Users</MenuItem>
              )}
              {user?.role === "admin" && (
                <MenuItem onClick={() => { navigate("/manageuser"); handleMenuClose(); }}>Manage Users</MenuItem>
              )}
              {user?.role === "superuser" && (
                <MenuItem onClick={() => { handleMenuClose(); }}>Tally export data</MenuItem>
              )}
              <MenuItem onClick={() => { navigate("/receipt"); handleMenuClose(); }}>Receipt</MenuItem>
              <MenuItem onClick={logout}>Logout</MenuItem>
            </Menu>
          </>
        ) : (
          !isMobile && (
            <Box sx={{ display: "flex", gap: 2 }}>
              <Button
                variant="contained"
                sx={{
                  color: 'white',
                  background: 'linear-gradient(to left bottom, #47933A, #526626)',
                }}
                onClick={() => navigate("/register")}
              >
                New Member
              </Button>
              <Button
                variant="contained"
                sx={{
                  color: 'white',
                  background: 'linear-gradient(to left bottom, #B4AB57, #947F49)',
                }}
                onClick={() => navigate("/login")}
              >
                Registered Member
              </Button>
            </Box>
          )
        )}

        {/* Mobile Menu Button */}
        {isMobile && !user && (
          <IconButton onClick={toggleDrawer(true)} sx={{ color: "black" }}>
            <MenuIcon />
          </IconButton>
        )}
      </Toolbar>
      {/* Mobile Drawer (Side Menu) */}
      <Drawer anchor="left" open={openDrawer} onClose={toggleDrawer(false)}>
        <Box sx={{ width: 250, padding: 2 }}>
          {/* Close Button */}
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <img src={logo} alt="Temple Logo" style={{ width: "100px", height: "auto" }} />
            <IconButton onClick={toggleDrawer(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
          <List>
            {navLinks.map((link, index) => (
              <ListItem button key={index} onClick={() => handleNavigation(link.path)}>
                <ListItemText primary={link.title} />
              </ListItem>
            ))}
          </List>
          <Divider />
          {user ? (
            <List>
              <ListItem button onClick={() => navigate("/profile")}>
                <ListItemText primary="My Profile" />
              </ListItem>
              <ListItem button onClick={() => navigate("/membership")}>
                <ListItemText primary="Membership ID" />
              </ListItem>
              <ListItem button onClick={() => navigate("/")}>
                <ListItemText primary="Logout" />
              </ListItem>
            </List>
) : (
            <List>
              <ListItem button onClick={() => handleNavigation("/register")}>
              <ListItemText primary="NEW MEMBER" />
            </ListItem>
            <ListItem button onClick={() => handleNavigation("/login")}>
              <ListItemText primary="REGISTERED MEMBER" />
            </ListItem>
            </List>
          )}
        </Box>
      </Drawer>
    </AppBar>
  );
};
export default Header;